import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

const NoMatchPage = () => {
    const { t } = useTranslation();

    return <h1 className={styles.title}>{t("noPage")}</h1>;
};

export default NoMatchPage;
